/**
 * Home Ingredients Slider using Swiper
 * Shows 3 slides with center slide zoomed
 * Description popup appears when clicking navigation arrows
 * Mobile: init after first slide image loads to avoid blocking LCP.
 */

function initIngredientsSwiperWhenReady(element, callback) {
  const firstSlide = element.querySelector('.swiper-slide');
  const img = firstSlide?.querySelector('img');
  const timeout = 3000;
  if (!img || img.complete) {
    callback();
    return;
  }
  const done = () => {
    img.removeEventListener('load', onDone);
    img.removeEventListener('error', onDone);
    clearTimeout(timer);
    callback();
  };
  const onDone = () => done();
  img.addEventListener('load', onDone, { once: true });
  img.addEventListener('error', onDone, { once: true });
  const timer = setTimeout(done, timeout);
}

function initIngredientsSwiper(element) {
  const totalSlides = element.querySelectorAll('.swiper-slide').length;
  // Start at slide 1 (2nd slide, 0-indexed) to show 3 slides with center zoomed
  const initialSlide = totalSlides > 1 ? 1 : 0;
  
  const swiper = new Swiper(element, {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    initialSlide: initialSlide,
    loop: false,
    speed: 600,
    navigation: {
      nextEl: element.closest('.ingredients__slider-wrapper').querySelector('.swiper-button-next'),
      prevEl: element.closest('.ingredients__slider-wrapper').querySelector('.swiper-button-prev'),
    },
    // Ensure correct arrow directions
    watchOverflow: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
        initialSlide: 0,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
        initialSlide: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        initialSlide: totalSlides > 2 ? 1 : 0,
      },
    },
    // Touch/swipe support
    touchEventsTarget: 'container',
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    // Update on slide change
    on: {
      slideChange: function() {
        updateActiveSlide(this);
        closeAllPopups();
      },
      init: function() {
        const swiperInstance = this;
        // Wait for Swiper to fully initialize
        setTimeout(() => {
          updateActiveSlide(swiperInstance);
          if (swiperInstance.update) {
            swiperInstance.update();
          }
        }, 50);
      },
      resize: function() {
        updateActiveSlide(this);
      },
    },
  });

  // Store swiper instance on element for later access
  element.swiperInstance = swiper;

  // Setup navigation arrow click handlers for popup
  setupNavigationHandlers(element, swiper);
}

function updateActiveSlide(swiper) {
  const slides = swiper.slides;
  const activeIndex = swiper.activeIndex;

  slides.forEach((slide, index) => {
    if (index === activeIndex) {
      slide.classList.add('swiper-slide-active');
    } else {
      slide.classList.remove('swiper-slide-active');
    }
  });
}

function setupNavigationHandlers(element, swiper) {
  const wrapper = element.closest('.ingredients__slider-wrapper');
  const nextButton = wrapper.querySelector('.swiper-button-next');
  const prevButton = wrapper.querySelector('.swiper-button-prev');

  // Navigation arrows just navigate - close any open popups first
  if (nextButton) {
    nextButton.addEventListener('click', () => {
      closeAllPopups();
    });
  }

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      closeAllPopups();
    });
  }

  // Setup close buttons for all popups
  const closeButtons = wrapper.querySelectorAll('.ingredients__popup-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeAllPopups();
    });
  });

  // Setup arrow button clicks to show description overlay
  const arrowButtons = wrapper.querySelectorAll('.ingredients__arrow-button');
  arrowButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const popupIndex = button.getAttribute('data-popup-trigger');
      const slide = button.closest('.ingredients__slide');
      const popup = slide ? slide.querySelector(`[data-popup-index="${popupIndex}"]`) : null;
      if (popup) {
        showPopup(popup);
      }
    });
  });
}

function showPopup(popup) {
  if (!popup) return;
  
  // Close any other open popups first
  closeAllPopups();
  
  // Show popup overlay on image
  popup.classList.add('active');
}

function closeAllPopups() {
  const popups = document.querySelectorAll('.ingredients__popup-description.active');
  
  popups.forEach(popup => {
    popup.classList.remove('active');
  });
}

// Close popup on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeAllPopups();
  }
});

// Initialize on DOM ready — after first slide image loads (mobile LCP)
document.addEventListener('DOMContentLoaded', () => {
  const swiperElements = document.querySelectorAll('[data-ingredients-swiper]');
  swiperElements.forEach((element) => {
    initIngredientsSwiperWhenReady(element, () => initIngredientsSwiper(element));
  });
});

// Also initialize for dynamically loaded content
if (document.readyState !== 'loading') {
  const swiperElements = document.querySelectorAll('[data-ingredients-swiper]');
  swiperElements.forEach((element) => {
    if (!element.swiperInstance) {
      initIngredientsSwiperWhenReady(element, () => initIngredientsSwiper(element));
    }
  });
}

// Handle section re-renders (Shopify theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    const swiperElement = section.querySelector('[data-ingredients-swiper]');
    if (swiperElement && !swiperElement.swiperInstance) {
      initIngredientsSwiperWhenReady(swiperElement, () => initIngredientsSwiper(swiperElement));
    }
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    const swiperElement = section.querySelector('[data-ingredients-swiper]');
    if (swiperElement && swiperElement.swiperInstance) {
      swiperElement.swiperInstance.destroy(true, true);
      swiperElement.swiperInstance = null;
    }
  });
}

